import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'weekYear',
  pure: false,
  standalone: true
})
export class WeekYearPipe implements PipeTransform {
  transform(date: Date | DateTime): number {
    const value = date instanceof DateTime ? date : DateTime.fromJSDate(date);
    return value.weekYear;
  }
}
